<template>
  <div>
    <a-modal
      :visible="visible"
      title="新增预警规则"
      width="920px"
      class="warmModal"
      centered
      @ok="setMonitor"
      @cancel="handleCancel"
    >
      <div class="confBlock">
        <span class="cofBlockName">预警范围</span>
        <div class="confContent">
          <div class="confLine">
            <span class="confLable">营销目标</span>
            <div class="confLineC">
              <a-radio-group
                disabled
                v-model="marketing_goal"
                @change="markePurposeChange"
              >
                <a-radio-button
                  :value="item.value"
                  v-for="item in markePurposeLis"
                  :key="item.name"
                >
                  {{ item.name }}
                </a-radio-button>
              </a-radio-group>
            </div>
          </div>
          <div class="confLine fxStart">
            <span class="confLable"> 监视账户 </span>
            <div class="confLineC">
              <!-- <a-select
            class="filterItem"
            show-search
            placeholder="请选择要筛选的户"
            option-filter-prop="children"
            style="width: 200px" 
            @change="handleChange"
            v-model="advertiser_id"
          >
            <a-select-option
              v-for="(item, index) in advertiserList"
              :key="index"
              :value="item.advertiser_id"
            >
              {{ item.advertiser_name }}
            </a-select-option>
          </a-select> -->

              <!-- <AwemeList :dataSource="advertiserList" is_cache="0" :advertiser_id="advertiser_id" action="setAdvertiserId" @getAdvertiserId="getAdvertiserId" v-if="advertiserList.length > 0" /> -->

              {{ advertiser_id }}
            </div>
          </div>

          <div class="confLine fxStart" v-if="ad_id">
            <span class="confLable"> 选择计划 </span>
            <div class="confLineC" style="line-height: 32px">
              {{ ad_id }}
            </div>
          </div>
          <div class="confLine fxStart" v-if="product_id">
            <span class="confLable"> 选择商品 </span>
            <div class="confLineC" style="line-height: 32px">
              {{ product_id }}
            </div>
          </div>
          <div class="confLine fxStart">
            <span class="confLable"> 数据范围 </span>
            <div class="confLineC">
              <a-select
                v-model="warnCondition.day"
                style="width: 200px; color: red"
              >
                <a-select-option value="1">当日数据</a-select-option>
                <a-select-option value="3">近3天数据</a-select-option>
                <a-select-option value="7">近7天数据</a-select-option>
              </a-select>
            </div>
          </div>

          <div class="confLine fxStart">
            <span class="confLable"> 数据周期 </span>
            <div class="confLineC">
              <a-select
                v-model="warnCondition.data_period"
                style="width: 200px"
              >
                <a-select-option value="ALL_DATA">整体数据</a-select-option>
                <a-select-option value="OVER_ALL_DATA">乘方期间数据</a-select-option>
                <a-select-option value="UNI_DATA">全域期间数据</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
      </div>

      <div style="max-height: 800px; overflow: auto">
        <!-- 预警内容 -->
        <div class="confBlock">
          <span class="cofBlockName"
            >亏损关停
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.ksgt_open == 1"
              @change="warnCondition.ksgt_open = !warnCondition.ksgt_open"
          /></span>
          <div class="confContent" v-if="warnCondition.ksgt_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  【支付ROI】小于
                  <a-input-number
                    v-model="warnCondition.ksgt_json.roi"
                    class="conditionInput"
                    placeholder="请输入支付ROI"
                    :min="0.01"
                  />
                  (且)【消耗】大于
                  <a-input-number
                    placeholder="消耗"
                    v-model="warnCondition.ksgt_json.stat_cost"
                    :min="0.01"
                    :max="10000"
                  />
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时
                <a-select
                  v-model="warnCondition.ksgt_json.action"
                  style="width: 200px"
                  @change="handleKsgtChange"
                >
                  <a-select-option value="wx">微信通知</a-select-option>
                  <a-select-option value="wxstop"
                    >微信通知且自动关闭</a-select-option
                  >
                </a-select>

                <span> 执行次数：</span>

                <a-input-number
                  placeholder="次数"
                  v-model="warnCondition.ksgt_json.times"
                  :min="1"
                  :max="10"
                />
              </div>
            </div>

            <div class="confLine" v-if="warnCondition.ksgt_json.times > 1">
              <span class="confLable">消耗间隔</span>
              <div class="confLineC">
                每次执行时计划消耗间隔上次消耗相差
                <a-input
                  placeholder="消耗间隔"
                  class="conditionInput"
                  v-model="warnCondition.ksgt_json.differ"
                />
                元
              </div>
            </div>

            <div class="confLine">
              <span class="confLable">执行时段</span>
              <div class="confLineC">
                <a-input-number
                  placeholder="0点"
                  v-model="warnCondition.ksgt_json.start"
                  :min="0"
                  :max="24"
                />

                到
                <a-input-number
                  placeholder="24点"
                  v-model="warnCondition.ksgt_json.end"
                  :min="0"
                  :max="24"
                />

                （留空表示全天监控）
              </div>
            </div>

            <div class="confLine">
              <span class="confLable">开启操作</span>
              <div class="confLineC">
                <a-checkbox
                  :checked="
                    warnCondition.ksgt_json.isopen == '1' ? true : false
                  "
                  @change="onOpenChange"
                  >关停的计划隔天指定时间自动开启</a-checkbox
                >

                <a-time-picker
                  :allowClear="false"
                  v-if="warnCondition.ksgt_json.isopen == '1'"
                  @change="
                    (time, timeString) =>
                      onDayChange(time, timeString, 'ksgt_json')
                  "
                  :open.sync="day_time_open"
                  style="width: 100px"
                  :value="moment(warnCondition.ksgt_json.dotime, 'HH:mm')"
                  :default-value="
                    moment(warnCondition.ksgt_json.dotime, 'HH:mm')
                  "
                  format="HH:mm"
                >
                  <a-button
                    slot="addon"
                    size="small"
                    @click="day_time_open = false"
                    type="primary"
                    style="width: 100%"
                    >确定</a-button
                  >
                </a-time-picker>
                （勾选后隔天指定时间开启）
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >高产复开
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.gcfk_open == 1"
              @change="warnCondition.gcfk_open = !warnCondition.gcfk_open"
            />
            <b style="margin-left: 10px; color: red">New</b></span
          >
          <div class="confContent" v-if="warnCondition.gcfk_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  已关停计划仍在产生ROI，当【支付ROI】大于
                  <a-input
                    v-model="warnCondition.gcfk_json.roi"
                    class="conditionInput"
                    placeholder="请输入支付ROI"
                  />
                  【消耗】大于
                  <a-input
                    v-model="warnCondition.gcfk_json.stat_cost"
                    class="conditionInput"
                    placeholder="请输入消耗"
                  />
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时
                <a-select
                  :value="warnCondition.gcfk_json.action"
                  style="width: 200px"
                  @change="handleGcfkChange"
                >
                  <a-select-option value="wx">微信通知</a-select-option>
                  <a-select-option value="wxopen"
                    >微信通知且自动开启</a-select-option
                  >
                </a-select>
                <span> 执行次数：</span>
                <a-input-number
                  placeholder="次数"
                  v-model="warnCondition.gcfk_json.times"
                  :min="1"
                  :max="10"
                />
              </div>
            </div>

            <div class="confLine">
              <span class="confLable">执行时段</span>
              <div class="confLineC">
                <a-input-number
                  placeholder="0点"
                  v-model="warnCondition.gcfk_json.start"
                  :min="0"
                  :max="24"
                />

                到
                <a-input-number
                  placeholder="24点"
                  v-model="warnCondition.gcfk_json.end"
                  :min="0"
                  :max="24"
                />

                （留空表示全天监控）
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >追加预算
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.zjys_open == 1"
              @change="warnCondition.zjys_open = !warnCondition.zjys_open"
            />
            <b style="margin-left: 10px; color: red">New</b></span
          >
          <div class="confContent" v-if="warnCondition.zjys_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  【支付ROI】大于
                  <a-input
                    style="width: 80px"
                    v-model="warnCondition.zjys_json.roi"
                    class="conditionInput"
                    placeholder="支付ROI"
                  />
                  且【剩余预算】 小于
                  <a-input
                    placeholder="剩余预算"
                    v-model="warnCondition.zjys_json.differ"
                    style="width: 150px; margin-left: 10px"
                  >
                    <a-select
                      slot="addonAfter"
                      @change="changeDiffer"
                      :default-value="warnCondition.zjys_json.differ_unit"
                      style="width: 60px"
                    >
                      <a-select-option value="1"> 元 </a-select-option>
                      <a-select-option value="2"> % </a-select-option>
                    </a-select>
                  </a-input>
                  <span style="color: red">（剩余预算 = 预算-消耗）</span>
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时
                <a-select
                  :value="warnCondition.zjys_json.action"
                  style="width: 200px"
                  @change="handleZjysChange"
                >
                  <a-select-option value="wx">微信通知</a-select-option>
                  <a-select-option value="wxzt"
                    >微信通知且自动追加</a-select-option
                  >
                </a-select>
              </div>
            </div>
            <div
              class="confLine"
              v-if="warnCondition.zjys_json.action == 'wxzt'"
            >
              <span class="confLable">追加配置</span>
              <div class="confLineC">
                <div>
                  <div
                    class="external-action-wrapper"
                    style="text-align: left; line-height: 32px"
                  >
                    原计划预算基础上追加预算：
                    <a-input
                      placeholder="追加预算"
                      v-model="warnCondition.zjys_json.budget"
                      style="width: 150px; margin-right: 10px"
                    >
                      <a-select
                        slot="addonAfter"
                        @change="changeBudget"
                        :default-value="warnCondition.zjys_json.budget_unit"
                        style="width: 60px"
                      >
                        <a-select-option value="1"> 元 </a-select-option>
                        <a-select-option value="2"> % </a-select-option>
                      </a-select>
                    </a-input>
                    <span> 追加次数：</span>
                    <a-input-number
                      placeholder="消耗"
                      v-model="warnCondition.zjys_json.times"
                      :min="1"
                      :max="100"
                    />
                    次
                  </div>
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行时段</span>
              <div class="confLineC">
                <a-input-number
                  placeholder="0点"
                  v-model="warnCondition.zjys_json.start"
                  :min="0"
                  :max="24"
                />

                到
                <a-input-number
                  placeholder="24点"
                  v-model="warnCondition.zjys_json.end"
                  :min="0"
                  :max="24"
                />

                （留空表示全天监控）
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >定时改预算
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.xgys_open == 1"
              @change="warnCondition.xgys_open = !warnCondition.xgys_open"
            />
            <b style="margin-left: 10px; color: red">New</b></span
          >
          <div class="confContent" v-if="warnCondition.xgys_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  执行时间：
                  <a-date-picker
                    v-model="warnCondition.xgys_json.dotime"
                    :allowClear="false"
                    style="width: 200px"
                    format="YYYY-MM-DD HH:mm"
                    value-format="YYYY-MM-DD HH:mm"
                    placeholder="选择日期时间"
                    show-time
                  />
                  修改后的预算：
                  <a-input-number
                    v-model="warnCondition.xgys_json.new_budget"
                    :min="0"
                    :precision="0"
                    style="width: 200px"
                    placeholder="请输入修改后的预算金额"
                  />
                  <span style="margin-left: 8px; color: #666;">元</span>
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时
                <a-select
                  :value="warnCondition.xgys_json.action"
                  style="width: 200px"
                >
                  <a-select-option value="wxedit"
                    >微信通知且自动修改</a-select-option
                  >
                </a-select>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">生效范围</span>
              <div class="confLineC" @click="getAd('xgys_json')" v-if="!ad_id">
                <a>选择计划</a>
              </div>
              <div class="confLineC" v-else>
                {{ ad_id }}
              </div>
            </div>
          </div>
        </div>
        
        <div class="confBlock">
          <span class="cofBlockName"
            >定时关停
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.dsgt_open == 1"
              @change="warnCondition.dsgt_open = !warnCondition.dsgt_open"
            />
            <b style="margin-left: 10px; color: red">New</b></span
          >
          <div class="confContent" v-if="warnCondition.dsgt_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  每日：
                  <a-time-picker
                    :allowClear="false"
                    @change="
                      (time, timeString) =>
                        onDayChange(time, timeString, 'dsgt_json')
                    "
                    :open.sync="stop_time_open"
                    style="width: 100px"
                    :value="moment(warnCondition.dsgt_json.dotime, 'HH:mm')"
                    :default-value="
                      moment(warnCondition.dsgt_json.dotime, 'HH:mm')
                    "
                    format="HH:mm"
                  >
                    <a-button
                      slot="addon"
                      size="small"
                      @click="stop_time_open = false"
                      type="primary"
                      style="width: 100%"
                      >确定</a-button
                    >
                  </a-time-picker>
                  关停
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时
                <a-select
                  :value="warnCondition.dsgt_json.action"
                  style="width: 200px"
                >
                  <a-select-option value="wxstop"
                    >微信通知且自动关停</a-select-option
                  >
                </a-select>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">生效范围</span>
              <div class="confLineC" @click="getAd('dsgt_json')" v-if="!ad_id">
                <a>选择计划</a>
              </div>
              <div class="confLineC" v-else>
                {{ ad_id }}
              </div>
            </div>
            <div
              class="confLine"
              v-if="
                warnCondition.dsgt_json.ad_ids &&
                warnCondition.dsgt_json.ad_ids.length > 0 &&
                !ad_id
              "
            >
              <span class="confLable">已选计划</span>
              <div class="confLineC">
                <div class="tags-area-body">
                  <div
                    class="tag"
                    v-for="(it, i) in warnCondition.dsgt_json.ad_ids"
                    v-bind:key="i"
                  >
                    <span
                      class="ellipsis-text"
                      style="
                        width: 167px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgb(50, 51, 53);
                      "
                    >
                      {{ it }}
                    </span>
                    <div class="tag-icon">
                      <a-icon type="close" @click="delAd(it, 'dsgt_json')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >定时开启
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.dsfk_open == 1"
              @change="warnCondition.dsfk_open = !warnCondition.dsfk_open"
            />
            <b style="margin-left: 10px; color: red">New</b></span
          >
          <div class="confContent" v-if="warnCondition.dsfk_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  每日：
                  <a-time-picker
                    :allowClear="false"
                    @change="
                      (time, timeString) =>
                        onDayChange(time, timeString, 'dsfk_json')
                    "
                    :open.sync="open_time_open"
                    style="width: 100px"
                    :value="moment(warnCondition.dsfk_json.dotime, 'HH:mm')"
                    :default-value="
                      moment(warnCondition.dsfk_json.dotime, 'HH:mm')
                    "
                    format="HH:mm"
                  >
                    <a-button
                      slot="addon"
                      size="small"
                      @click="open_time_open = false"
                      type="primary"
                      style="width: 100%"
                      >确定</a-button
                    >
                  </a-time-picker>
                  开启
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时
                <a-select
                  :value="warnCondition.dsfk_json.action"
                  style="width: 200px"
                >
                  <a-select-option value="wxopen"
                    >微信通知且自动开启</a-select-option
                  >
                </a-select>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">生效范围</span>
              <div class="confLineC" @click="getAd('dsfk_json')" v-if="!ad_id">
                <a>选择计划</a>
              </div>
              <div class="confLineC" v-else>
                {{ ad_id }}
              </div>
            </div>
            <div
              class="confLine"
              v-if="
                warnCondition.dsfk_json.ad_ids &&
                warnCondition.dsfk_json.ad_ids.length > 0 &&
                !ad_id
              "
            >
              <span class="confLable">已选计划</span>
              <div class="confLineC">
                <div class="tags-area-body">
                  <div
                    class="tag"
                    v-for="(it, i) in warnCondition.dsfk_json.ad_ids"
                    v-bind:key="i"
                  >
                    <span
                      class="ellipsis-text"
                      style="
                        width: 167px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgb(50, 51, 53);
                      "
                    >
                      {{ it }}
                    </span>
                    <div class="tag-icon">
                      <a-icon type="close" @click="delAd(it, 'dsfk_json')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >多时段关停
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.dsgt_multi_open == 1"
              @change="warnCondition.dsgt_multi_open = !warnCondition.dsgt_multi_open"
            />
            <b style="margin-left: 10px; color: red">New</b></span
          >
          <div class="confContent" v-if="warnCondition.dsgt_multi_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition" style="flex-wrap: wrap;">
                  <div 
                    v-for="(time, index) in warnCondition.dsgt_multi_json.times" 
                    :key="index"
                    style="display: flex; align-items: center; margin-bottom: 10px; width: 100%;"
                  >
                    <span style="margin-right: 5px;">时段{{ index + 1 }}：</span>
                    <a-time-picker
                      :allowClear="false"
                      @change="
                        (t, timeString) =>
                          onMultiTimeChange(timeString, index, 'dsgt_multi_json')
                      "
                      style="width: 100px; margin-right: 10px;"
                      :value="moment(time, 'HH:mm')"
                      :default-value="moment(time, 'HH:mm')"
                      format="HH:mm"
                    />
                    <span style="margin-right: 10px;">关停</span>
                    <a-icon 
                      type="delete" 
                      @click="removeMultiTime(index, 'dsgt_multi_json')"
                      style="color: #ff4d4f; cursor: pointer; font-size: 16px;"
                      v-if="warnCondition.dsgt_multi_json.times.length > 1"
                    />
                  </div>
                  <a-button 
                    type="dashed" 
                    @click="addMultiTime('dsgt_multi_json')"
                    style="width: 100%; margin-top: 10px;"
                    :disabled="warnCondition.dsgt_multi_json.times.length >= 10"
                  >
                    <a-icon type="plus" />
                    添加时段
                  </a-button>
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时
                <a-select
                  :value="warnCondition.dsgt_multi_json.action"
                  style="width: 200px"
                  @change="(value) => warnCondition.dsgt_multi_json.action = value"
                >
                  <a-select-option value="wxstop"
                    >微信通知且自动关停</a-select-option
                  >
                </a-select>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">生效范围</span>
              <div class="confLineC" @click="getAd('dsgt_multi_json')" v-if="!ad_id">
                <a>选择计划</a>
              </div>
              <div class="confLineC" v-else>
                {{ ad_id }}
              </div>
            </div>
            <div
              class="confLine"
              v-if="
                warnCondition.dsgt_multi_json.ad_ids &&
                warnCondition.dsgt_multi_json.ad_ids.length > 0 &&
                !ad_id
              "
            >
              <span class="confLable">已选计划</span>
              <div class="confLineC">
                <div class="tags-area-body">
                  <div
                    class="tag"
                    v-for="(it, i) in warnCondition.dsgt_multi_json.ad_ids"
                    v-bind:key="i"
                  >
                    <span
                      class="ellipsis-text"
                      style="
                        width: 167px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgb(50, 51, 53);
                      "
                    >
                      {{ it }}
                    </span>
                    <div class="tag-icon">
                      <a-icon type="close" @click="delAd(it, 'dsgt_multi_json')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!-- 
        <div class="confBlock">
          <span class="cofBlockName"
            >多时段开启
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.dsfk_multi_open == 1"
              @change="warnCondition.dsfk_multi_open = !warnCondition.dsfk_multi_open"
            />
            <b style="margin-left: 10px; color: red">New</b></span
          >
          <div class="confContent" v-if="warnCondition.dsfk_multi_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition" style="flex-wrap: wrap;">
                  <div 
                    v-for="(time, index) in warnCondition.dsfk_multi_json.times" 
                    :key="index"
                    style="display: flex; align-items: center; margin-bottom: 10px; width: 100%;"
                  >
                    <span style="margin-right: 5px;">时段{{ index + 1 }}：</span>
                    <a-time-picker
                      :allowClear="false"
                      @change="
                        (t, timeString) =>
                          onMultiTimeChange(timeString, index, 'dsfk_multi_json')
                      "
                      style="width: 100px; margin-right: 10px;"
                      :value="moment(time, 'HH:mm')"
                      :default-value="moment(time, 'HH:mm')"
                      format="HH:mm"
                    />
                    <span style="margin-right: 10px;">开启</span>
                    <a-icon 
                      type="delete" 
                      @click="removeMultiTime(index, 'dsfk_multi_json')"
                      style="color: #ff4d4f; cursor: pointer; font-size: 16px;"
                      v-if="warnCondition.dsfk_multi_json.times.length > 1"
                    />
                  </div>
                  <a-button 
                    type="dashed" 
                    @click="addMultiTime('dsfk_multi_json')"
                    style="width: 100%; margin-top: 10px;"
                    :disabled="warnCondition.dsfk_multi_json.times.length >= 10"
                  >
                    <a-icon type="plus" />
                    添加时段
                  </a-button>
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时
                <a-select
                  :value="warnCondition.dsfk_multi_json.action"
                  style="width: 200px"
                  @change="(value) => warnCondition.dsfk_multi_json.action = value"
                >
                  <a-select-option value="wxopen"
                    >微信通知且自动开启</a-select-option
                  >
                </a-select>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">生效范围</span>
              <div class="confLineC" @click="getAd('dsfk_multi_json')" v-if="!ad_id">
                <a>选择计划</a>
              </div>
              <div class="confLineC" v-else>
                {{ ad_id }}
              </div>
            </div>
            <div
              class="confLine"
              v-if="
                warnCondition.dsfk_multi_json.ad_ids &&
                warnCondition.dsfk_multi_json.ad_ids.length > 0 &&
                !ad_id
              "
            >
              <span class="confLable">已选计划</span>
              <div class="confLineC">
                <div class="tags-area-body">
                  <div
                    class="tag"
                    v-for="(it, i) in warnCondition.dsfk_multi_json.ad_ids"
                    v-bind:key="i"
                  >
                    <span
                      class="ellipsis-text"
                      style="
                        width: 167px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgb(50, 51, 53);
                      "
                    >
                      {{ it }}
                    </span>
                    <div class="tag-icon">
                      <a-icon type="close" @click="delAd(it, 'dsfk_multi_json')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >快消提醒
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.kxtx_open == 1"
              @change="warnCondition.kxtx_open = !warnCondition.kxtx_open"
            />
          </span>
          <div class="confContent" v-if="warnCondition.kxtx_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  <a-input
                    placeholder="请输入时间"
                    v-model="warnCondition.kxtx_minute"
                    style="width: 80px"
                  />
                  分钟内 当计划【消耗】大于

                  <a-input
                    v-model="warnCondition.kxtx_json.stat_cost"
                    class="conditionInput"
                    placeholder="请输入金额"
                  />
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">当触发以上条件时触发【微信通知】</div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >跑飞关停
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.pfgt_open == 1"
              @change="warnCondition.pfgt_open = !warnCondition.pfgt_open"
            />
          </span>
          <div class="confContent" v-if="warnCondition.pfgt_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  <a-input
                    placeholder="请输入时间"
                    v-model="warnCondition.pfgt_minute"
                    style="width: 80px"
                  />
                  分钟内 当计划【消耗】大于
                  <a-input
                    v-model="warnCondition.pfgt_json.stat_cost"
                    class="conditionInput"
                    placeholder="请输入金额"
                  />
                  且 【支付roi】 小于
                  <a-input
                    v-model="warnCondition.pfgt_json.roi"
                    class="conditionInput"
                    placeholder="请输入roi"
                  />
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                当触发以上条件时触发【微信通知且关停】
              </div>
            </div>
          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >预算监控
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.ysjk_open == 1"
              @change="warnCondition.ysjk_open = !warnCondition.ysjk_open"
            />
          </span>
          <div class="confContent" v-if="warnCondition.ysjk_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC"  style="display: flex;line-height: 35px;">
                <div class="actionCondition">
                  当计划【剩余预算】小于
                  <a-input
                    placeholder="剩余预算"
                    v-model="warnCondition.ysjk_json.differ"
                    style="width: 150px; margin-left: 10px"
                  >
                    <a-select
                      slot="addonAfter"
                      @change="changeYsDiffer"
                      :default-value="warnCondition.ysjk_json.differ_unit"
                      style="width: 60px"
                    >
                      <a-select-option value="1"> 元 </a-select-option>
                      <a-select-option value="2"> % </a-select-option>
                    </a-select>
                  </a-input>
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">当触发以上条件时触发【微信通知】</div>
            </div>
          </div>
        </div>


        <div class="confBlock">
          <span class="cofBlockName"
            >改300预算{{ warnCondition.buget_open }}
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.buget_open == 1"
              @change="warnCondition.buget_open = !warnCondition.buget_open"
            />
          </span>
          <div class="confContent" v-if="warnCondition.buget_open == 1">
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">当所有投放中控成本计划预算超300时，隔天0点计划预算改回300</div>
            </div>
          </div>
        </div>



        <div class="confBlock">
          <span class="cofBlockName"
            >自动重建
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.zdcj_open == 1"
              @change="warnCondition.zdcj_open = !warnCondition.zdcj_open"
            />(该功能配置后联系客服报白) 
          </span>
          <div class="confContent" v-if="warnCondition.zdcj_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  近
                  <a-input-number
                    placeholder="天数"
                    v-model="warnCondition.zdcj_json.day"
                    :min="1"
                    :max="90"
                  />
                  天内出单数小于等于
                  <a-input-number
                    placeholder="单数"
                    v-model="warnCondition.zdcj_json.count"
                    :min="0"
                    :max="100"
                  />
                  单
                  且 消耗 
                  <a-select
                    :value="warnCondition.zdcj_json.relation"
                    style="margin: 0 10px;width: 100px;"
                    @change="handleZdcjChange"
                  >
                    <a-select-option value=">">大于</a-select-option>
                    <a-select-option value="<=">小于等于</a-select-option>
                  </a-select>
                   <a-input-number
                    placeholder="金额"
                    v-model="warnCondition.zdcj_json.stat_cost"
                    :min="0"
                  />
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">时间范围</span>
              <div class="confLineC" style="display: flex;line-height: 35px;">
                <a-range-picker
                :ranges="{
                  今日: [moment(), moment()],
                  昨日: [
                    moment().subtract(1, 'days'),
                    moment().subtract(1, 'days'),
                  ],
                  本周: [moment().startOf('week'), moment()],
                  上周: [
                    moment().subtract(1, 'week').startOf('week'),
                    moment().subtract(1, 'week').endOf('week'),
                  ],
                  本月: [moment().startOf('month'), moment()],
                  上月: [
                    moment().subtract(1, 'month').startOf('month'),
                    moment().subtract(1, 'month').endOf('month'),
                  ],
                }"
                :value="[this.warnCondition.zdcj_json.start,this.warnCondition.zdcj_json.end]"
                class="w-64"
                :placeholder="['开始时间', '结束时间']"
                @change="handleRangeChange"
              />
                (有选择即表示只监控计划创建时间在设定的时间段内的计划)
              </div>
            </div>

            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC" style="display: flex;line-height: 35px;">
                
                <a-select
                  :value="warnCondition.zdcj_json.action"
                  style="margin-right:10px;width: 150px;"
                  @change="handleZdcjActionChange"
                >
                  <a-select-option value="wcbdelcj">无成本保障删除重建</a-select-option>
                  <a-select-option value="delcj">删除重建</a-select-option>
                  <a-select-option value="del">仅删除</a-select-option>
                  <a-select-option value="cbdel">有成本保障删除</a-select-option>
                  <a-select-option value="wcbdel">无成本保障删除</a-select-option>
                </a-select>
                
                <span v-if="showZdcjRoiAdjustment">
                  <a-select
                    :value="warnCondition.zdcj_json.type"
                    style="margin-right:10px;width: 100px;"
                    @change="handleZdcjTypeChange"
                  >
                    <a-select-option value="del">减少ROI</a-select-option>
                    <a-select-option value="add">增加ROI</a-select-option>
                  </a-select>
                  <a-input-number
                    style="width: 120px;"
                    :placeholder="warnCondition.zdcj_json.type === 'add' ? '增加ROI' : '减少ROI'"
                    :value="Number(warnCondition.zdcj_json.reduce_roi)"
                    :min="0"
                    :max="50"
                    @change="handleZdcjReduceChange"
                  />
                  <span style="margin-left: 4px;">%</span>
                </span>

                <span style="margin-left: 5px;" v-if="showZdcjMinRoi">
                  
                  ROI最低将至：
                  <a-input-number
                    placeholder="ROI"
                    v-model="warnCondition.zdcj_json.min_roi"
                    :min="0"
                    @change="handleZdcjMinRoiChange"
                  /> 
                </span>

              </div>
            </div>

            
            <div class="confLine">
              <span class="confLable">限制数量</span>
              <div class="confLineC" style="display: flex;line-height: 35px;">
                <a-input-number
                  placeholder="数量"
                  v-model="warnCondition.zdcj_json.limit"
                />
                个
                （单账户每日最多操作计划数）
                
                <span style="margin-left: 5px;">推送微信通知<a-switch style="margin-left: 5px;"
                    v-model="warnCondition.zdcj_json.push_notice"
                    :checked="warnCondition.zdcj_json.push_notice"
                  /></span>

                  

                  <span style="margin-left: 5px;">
                    <a-checkbox v-model="warnCondition.zdcj_json.dubble" :checked="warnCondition.zdcj_json.dubble">已重建过不再次操作</a-checkbox>
                  </span>

               </div>
            </div>


            <div class="confLine">
              <span class="confLable">转净成交</span>
              <div class="confLineC" style="display: flex;line-height: 35px;">
                  <span style="margin-left: 5px;">
                    <a-checkbox v-model="warnCondition.zdcj_json.isjcj" :checked="warnCondition.zdcj_json.isjcj">整体支付ROI计划转净成交计划</a-checkbox>
                  </span>
               </div>
            </div>


          </div>
        </div>

        
        <div class="confBlock">
          <span class="cofBlockName"
            >转净成交
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.jcj_open == 1"
              @change="warnCondition.jcj_open = !warnCondition.jcj_open"
            /> (该功能配置后联系客服报白)
          </span>
          <div class="confContent" v-if="warnCondition.jcj_open == 1">  
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC" style="display: flex;line-height: 35px;"> 
                <span v-if="showJcjRoiAdjustment">
                  <a-select
                    :value="warnCondition.jcj_json.type"
                    style="margin-right:10px;width: 100px;"
                    @change="handleJcjTypeChange"
                  >
                    <a-select-option value="del">减少ROI</a-select-option> 
                  </a-select>
                  <a-input-number
                    style="width: 120px;"
                    :placeholder="warnCondition.jcj_json.type === 'add' ? '增加ROI' : '减少ROI'"
                    :value="Number(warnCondition.jcj_json.reduce_roi)"
                    :min="0"
                    :max="50"
                    @change="handleJcjReduceChange"
                  />
                  <span style="margin-left: 4px;">%</span>
                </span>
                <span style="margin-left: 5px;" v-if="showJcjMinRoi">
                  ROI最低将至：
                  <a-input-number
                    placeholder="ROI"
                    v-model="warnCondition.jcj_json.min_roi"
                    :min="0"
                    @change="handleJcjMinRoiChange"
                  /> 
                </span>
                （所有整体支付ROI计划转净成交计划） 
              </div>
            </div> 
          </div>
        </div>

        
        <div class="confBlock">
          <span class="cofBlockName"
            >关停所有投放中计划
            <a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.close_open == 1"
              @change="warnCondition.close_open = warnCondition.close_open == 1 ? 0 : 1"
            /> (该功能配置后联系客服报白)
          </span>
          <div class="confContent" v-if="warnCondition.close_open == 1">  
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC" style="display: flex;line-height: 35px;">  
                关停千川账户下所有投放中计划（支持关停后指定时间开启）
              </div>
            </div>
          </div>
        </div> -->

        <div class="confBlock">
          <span class="cofBlockName"
            >自定义监控<a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.diy_open == 1"
              @change="warnCondition.diy_open = !warnCondition.diy_open"
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div class="confContent" v-if="warnCondition.diy_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  <a-select
                    v-model="warnCondition.diy_json.x"
                    style="width: 120px"
                    placeholder="请选择"
                    @change="changeX"
                  >
                    <a-select-option
                      v-for="item in xData"
                      :key="item.value"
                      :value="item.name"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                  <a-select
                    :value="warnCondition.diy_json.x_relation"
                    style="margin: 0 10px"
                    @change="handleXChange"
                  >
                    <a-select-option value=">">大于</a-select-option>
                    <a-select-option value="<">小于</a-select-option>
                  </a-select>
                  <a-input
                    v-model="warnCondition.diy_json.x_value"
                    class="conditionInput"
                    placeholder="请输入值"
                  />
                  且
                  <a-select
                    v-model="warnCondition.diy_json.y"
                    style="width: 120px"
                    placeholder="请选择"
                    @change="changeY"
                  >
                    <a-select-option
                      v-for="item in yData"
                      :key="item.value"
                      :value="item.name"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                  <a-select
                    :value="warnCondition.diy_json.y_relation"
                    style="margin: 0 10px"
                    @change="handleYChange"
                  >
                    <a-select-option value=">">大于</a-select-option>
                    <a-select-option value="<">小于</a-select-option>
                  </a-select>
                  <a-input
                    v-model="warnCondition.diy_json.y_value"
                    class="conditionInput"
                    placeholder="请输入值"
                  />
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                <a-select
                  :value="warnCondition.diy_json.action"
                  style="width: 200px"
                  @change="handleDiyChange"
                >
                  <a-select-option value="wx">微信通知</a-select-option>
                  <a-select-option value="wxstop"
                    >微信通知且自动关停</a-select-option
                  >
                </a-select>
              </div>
            </div>

            <div class="confLine">
              <span class="confLable">执行时段</span>
              <div class="confLineC">
                <a-input-number
                  placeholder="0点"
                  v-model="warnCondition.diy_json.start"
                  :min="0"
                  :max="24"
                />

                到
                <a-input-number
                  placeholder="24点"
                  v-model="warnCondition.diy_json.end"
                  :min="0"
                  :max="24"
                />

                （留空表示全天监控）
              </div>
            </div>

            <div class="confLine" v-if="warnCondition.diy_json.action == 'wxstop'">
              <span class="confLable">开启操作</span>
              <div class="confLineC">
                <a-checkbox
                  :checked="
                    warnCondition.diy_json.isopen == '1' ? true : false
                  "
                  @change="onDiyOpenChange"
                  >关停的计划隔天指定时间自动开启</a-checkbox
                >

                <a-time-picker
                  :allowClear="false"
                  v-if="warnCondition.diy_json.isopen == '1'"
                  @change="
                    (time, timeString) =>
                      onDayChange(time, timeString, 'diy_json')
                  "
                  :open.sync="diy_day_time_open"
                  style="width: 100px"
                  :value="moment(warnCondition.diy_json.dotime, 'HH:mm')"
                  :default-value="
                    moment(warnCondition.diy_json.dotime, 'HH:mm')
                  "
                  format="HH:mm"
                >
                  <a-button
                    slot="addon"
                    size="small"
                    @click="diy_day_time_open = false"
                    type="primary"
                    style="width: 100%"
                    >确定</a-button
                  >
                </a-time-picker>
                （勾选后隔天指定时间开启）
              </div>
            </div>

            


          </div>
        </div>

        <div class="confBlock">
          <span class="cofBlockName"
            >自定义监控2<a-switch
              checked-children="开"
              un-checked-children="关"
              :checked="warnCondition.diy2_open == 1"
              @change="warnCondition.diy2_open = !warnCondition.diy2_open"
            />
            <b style="margin-left: 10px; color: red">New</b>
          </span>
          <div class="confContent" v-if="warnCondition.diy2_open == 1">
            <div class="confLine fxStart">
              <span class="confLable">执行条件</span>
              <div class="confLineC">
                <div class="actionCondition">
                  <a-select
                    v-model="warnCondition.diy2_json.x"
                    style="width: 100px"
                    placeholder="请选择"
                    @change="changeX2"
                  >
                    <a-select-option
                      v-for="item in xData2"
                      :key="item.value"
                      :value="item.name"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                  <a-select
                    :value="warnCondition.diy2_json.x_relation"
                    style="margin: 0 10px"
                    @change="handleXChange2"
                  >
                    <a-select-option value=">">大于</a-select-option>
                    <a-select-option value="<">小于</a-select-option>
                  </a-select>
                  <a-input
                    v-model="warnCondition.diy2_json.x_value"
                    class="conditionInput"
                    placeholder="请输入值"
                  />
                  且
                  <a-select
                    v-model="warnCondition.diy2_json.y"
                    style="width: 100px"
                    placeholder="请选择"
                    @change="changeY2"
                  >
                    <a-select-option
                      v-for="item in yData2"
                      :key="item.value"
                      :value="item.name"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                  <a-select
                    :value="warnCondition.diy2_json.y_relation"
                    style="margin: 0 10px"
                    @change="handleYChange2"
                  >
                    <a-select-option value=">">大于</a-select-option>
                    <a-select-option value="<">小于</a-select-option>
                  </a-select>
                  <a-input
                    v-model="warnCondition.diy2_json.y_value"
                    class="conditionInput"
                    placeholder="请输入值"
                  />
                  <!-- 且
                  <a-select
                    v-model="warnCondition.diy2_json.z"
                    style="width: 100px"
                    placeholder="请选择"
                    @change="changeZ2"
                  >
                    <a-select-option
                      v-for="item in zData2"
                      :key="item.value"
                      :value="item.name"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                  <a-select
                    :value="warnCondition.diy2_json.z_relation"
                    style="margin: 0 10px"
                    @change="handleZChange2"
                  >
                    <a-select-option value=">">大于</a-select-option>
                    <a-select-option value="<">小于</a-select-option>
                  </a-select>
                  <a-input
                    v-model="warnCondition.diy2_json.z_value"
                    class="conditionInput"
                    placeholder="请输入值"
                  /> -->
                </div>
              </div>
            </div>
            <div class="confLine">
              <span class="confLable">执行操作</span>
              <div class="confLineC">
                <a-select
                  :value="warnCondition.diy2_json.action"
                  style="width: 200px"
                  @change="handleDiyChange2"
                >
                  <a-select-option value="wx">微信通知</a-select-option>
                  <a-select-option value="wxstop"
                    >微信通知且自动关停</a-select-option
                  >
                </a-select>
              </div>
            </div>

            <div class="confLine">
              <span class="confLable">执行时段</span>
              <div class="confLineC">
                <a-input-number
                  placeholder="0点"
                  v-model="warnCondition.diy2_json.start"
                  :min="0"
                  :max="24"
                />

                到
                <a-input-number
                  placeholder="24点"
                  v-model="warnCondition.diy2_json.end"
                  :min="0"
                  :max="24"
                />

                （留空表示全天监控）
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="font-size: 12px; color: #999">
        免责声明：尊敬的用户，因自动化预警功能的实现需要抖音官方Markting API
        接口返回数据，如因官方接口返回数据或其他数据异常导致执行操作错误，抖川助手不承担任何法律责任。
      </div>
    </a-modal>

    <a-drawer
      v-if="adDrawer"
      class="authAccount"
      title="选择计划"
      width="70%"
      placement="right"
      :visible="adDrawer"
      @close="adDrawer = false"
    >
      <div class="searchResult">
        <AdVideoList
          ref="adlist"
          :selectKeys="warnCondition[pz].ad_ids || []"
          v-if="marketing_goal == 'VIDEO_PROM_GOODS'"
          :marketing_goal="marketing_goal"
          :advertiser_id="advertiser_id"
          @selectAdDrawer="selectAdDrawer"
          @closeAdDrawer="closeAdDrawer"
        />

        <AdLiveList
          ref="adlist"
          :selectKeys="warnCondition[pz].ad_ids || []"
          v-if="marketing_goal == 'LIVE_PROM_GOODS'"
          :marketing_goal="marketing_goal"
          :advertiser_id="advertiser_id"
          @selectAdDrawer="selectAdDrawer"
          @closeAdDrawer="closeAdDrawer"
        />
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { qcApi, requestHttp, isNumber } from '@utils/index';
import awemeList from '../../batchCreatePlan/components/awemeList.vue';
import AdVideoList from './adVideoList.vue';
import AdLiveList from './adLiveList.vue';
import moment from 'moment';
export default {
  name: 'warnRuleModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    advertiserList: {
      type: Array,
    },
    advertiser_id: {
      type: String,
      default: '',
    },
    marketing_goal: {
      type: String,
      default: '',
    },
    ad_id: {
      type: String,
      default: '',
    },
    product_id: {
      type: String,
      default: '',
    },
    monitor_type: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      markePurposeLis: [
        {
          name: '推商品',
          value: 'VIDEO_PROM_GOODS',
        },
        {
          name: '推直播',
          value: 'LIVE_PROM_GOODS',
        },
      ],
      xData: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: false,
        },
        {
          value: '1',
          name: 'total_pay_order_count_for_roi2',
          label: '成交订单数',
          disabled: false,
        },
        {
          value: '2',
          name: 'total_pay_order_gmv_for_roi2',
          label: '成交金额',
          disabled: false,
        },
        {
          value: '3',
          name: 'total_prepay_and_pay_order_roi2',
          label: '支付ROI',
          disabled: true,
        },
        {
          value: '4',
          name: 'total_pay_order_coupon_amount_for_roi2',
          label: '智能优惠券金额',
          disabled: false,
        },
        {
          value: '5',
          name: 'total_cost_per_pay_order_for_roi2',
          label: '成交订单成本',
          disabled: false,
        },
          {
            value: '6',
            name: 'total_prepay_and_pay_settle_roi2_1h',
            label: '净成交ROI',
            disabled: false
          } 
      ],
      yData: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: true,
        },
        {
          value: '1',
          name: 'total_pay_order_count_for_roi2',
          label: '成交订单数',
          disabled: false,
        },
        {
          value: '2',
          name: 'total_pay_order_gmv_for_roi2',
          label: '成交金额',
          disabled: false,
        },
        {
          value: '3',
          name: 'total_prepay_and_pay_order_roi2',
          label: '支付ROI',
          disabled: false,
        },
        {
          value: '4',
          name: 'total_pay_order_coupon_amount_for_roi2',
          label: '智能优惠券金额',
          disabled: false,
        },
        {
          value: '5',
          name: 'total_cost_per_pay_order_for_roi2',
          label: '成交订单成本',
          disabled: false,
        },
          {
            value: '6',
            name: 'total_prepay_and_pay_settle_roi2_1h',
            label: '净成交ROI',
            disabled: false
          } 
      ],
      xData2: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: false,
        },
        {
          value: '1',
          name: 'total_pay_order_count_for_roi2',
          label: '成交订单数',
          disabled: false,
        },
        {
          value: '2',
          name: 'total_pay_order_gmv_for_roi2',
          label: '成交金额',
          disabled: false,
        },
        {
          value: '3',
          name: 'total_prepay_and_pay_order_roi2',
          label: '支付ROI',
          disabled: true,
        },
        {
          value: '4',
          name: 'total_pay_order_coupon_amount_for_roi2',
          label: '智能优惠券金额',
          disabled: false,
        },
        {
          value: '5',
          name: 'total_cost_per_pay_order_for_roi2',
          label: '成交订单成本',
          disabled: false,
        },
          {
            value: '6',
            name: 'total_prepay_and_pay_settle_roi2_1h',
            label: '净成交ROI',
            disabled: false
          } 
      ],
      yData2: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: true,
        },
        {
          value: '1',
          name: 'total_pay_order_count_for_roi2',
          label: '成交订单数',
          disabled: false,
        },
        {
          value: '2',
          name: 'total_pay_order_gmv_for_roi2',
          label: '成交金额',
          disabled: false,
        },
        {
          value: '3',
          name: 'total_prepay_and_pay_order_roi2',
          label: '支付ROI',
          disabled: false,
        },
        {
          value: '4',
          name: 'total_pay_order_coupon_amount_for_roi2',
          label: '智能优惠券金额',
          disabled: false,
        },
        {
          value: '5',
          name: 'total_cost_per_pay_order_for_roi2',
          label: '成交订单成本',
          disabled: false,
        },
          {
            value: '6',
            name: 'total_prepay_and_pay_settle_roi2_1h',
            label: '净成交ROI',
            disabled: false
          } 
      ],
      zData2: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: false,
        },
        {
          value: '1',
          name: 'total_pay_order_count_for_roi2',
          label: '成交订单数',
          disabled: false,
        },
        {
          value: '2',
          name: 'total_pay_order_gmv_for_roi2',
          label: '成交金额',
          disabled: false,
        },
        {
          value: '3',
          name: 'total_prepay_and_pay_order_roi2',
          label: '支付ROI',
          disabled: false,
        },
        {
          value: '4',
          name: 'total_pay_order_coupon_amount_for_roi2',
          label: '智能优惠券金额',
          disabled: false,
        },
        {
          value: '5',
          name: 'total_cost_per_pay_order_for_roi2',
          label: '成交订单成本',
          disabled: false,
        },
          {
            value: '6',
            name: 'total_prepay_and_pay_settle_roi2_1h',
            label: '净成交ROI',
            disabled: false
          } 
      ],
      start_open: false,
      end_open: false,
      warnCondition: {
        day: '1',
        data_period: 'ALL_DATA',
        ksgt_open: 1,
        ksgt_json: {
          roi: '',
          stat_cost: '',
          action: 'wxstop',
          times: '1',
          differ: '10',
          start: '',
          end: '',
          isopen: 0,
          dotime: '08:00',
        },
        gcft_open: 0,
        gcft_json: {
          roi: '',
          stat_cost: '',
          action: 'wxcreate',
          times: '1',
        },
        gcfk_open: 0,
        gcfk_json: {
          roi: '',
          stat_cost: '',
          action: 'wxopen',
          times: '1',
          start: '',
          end: '',
        },
        zjys_open: 0, //追加预算
        zjys_json: {
          roi: '',
          differ: '',
          differ_unit: '1',
          budget: '',
          budget_unit: '1',
          times: '1',
          action: 'wxzt',
          range: '0',
        },
        bdtz_open: 0,
        bdtz_json: {
          stat_cost: '',
          pay_order_count: '',
          times: 1,
        },
        zdyj_open: 0, //追加预算
        zdyj_json: {
          roi: '',
          differ: '',
          differ_unit: '1',
          budget: '',
          budget_unit: '1',
          bid: '',
          bid_unit: '1',
          yjroi: '',
          yjroi_unit: '1',
          times: '1',
          action: 'wxyj',
          range: '0',
          ad_ids: [],
          start: '',
          end: '',
        },
        xgys_open: 0, //定时改预算
        xgys_json: {
          action: 'wxedit',
          dotime: '', // 移除默认时间，让用户自由选择
          ad_ids: [],
          new_budget: '',
        },
        dsgt_open: 0, //定时关停
        dsgt_json: {
          action: 'wxstop',
          dotime: '04:00',
          ad_ids: [],
        },
        dsfk_open: 0, //定时开启
        dsfk_json: {
          action: 'wxopen',
          dotime: '08:00',
          ad_ids: [],
        },
        dsgt_multi_open: 0, //多时段关停
        dsgt_multi_json: {
          action: 'wxstop',
          times: ['04:00'],
          ad_ids: [],
        },
        dsfk_multi_open: 0, //多时段开启
        dsfk_multi_json: {
          action: 'wxopen',
          times: ['08:00'],
          ad_ids: [],
        },
        kxtx_open: 0,
        kxtx_minute: 10,
        kxtx_json: {
          stat_cost: '',
        },
        pfgt_open: 0,
        pfgt_json: {
          stat_cost: '',
          roi: '',
        },
        ysjk_open: 0,
        ysjk_json: {
          differ: '',
          differ_unit: '1',
        },
        zdcj_open: 0,
        zdcj_json: {
          day: '5',
          count: '1',
          stat_cost: '0',
          relation: '<=',
          reduce_roi: '0',
          push_notice: true,
          dubble: false,
          start: '',
          end: '',
          action: 'delcj',
          type: 'del',
          limit: '500',
          // 是否将整体支付 ROI 计划自动转为净成交计划（前端勾选“转净成交”）
          isjcj: false,
        },
        yjts_open: 0,
        diy_open: 0,
        diy_json: {
          x: 'stat_cost',
          x_value: '',
          x_relation: '>',
          y: 'total_prepay_and_pay_order_roi2',
          y_value: '',
          y_relation: '>',
          action: 'wxstop',
          start: '',
          end: '',
          isopen: 0,
          dotime: '08:00',
        },
        diy2_open: 0,
        diy2_json: {
          x: 'stat_cost',
          x_value: '',
          x_relation: '>',
          y: 'total_prepay_and_pay_order_roi2',
          y_value: '',
          y_relation: '>',
          z: 'total_pay_order_count_for_roi2',
          z_value: '',
          z_relation: '>',
          action: 'wxstop',
          start: '',
          end: '',
        },
        buget_open: 0,
        jcj_open: 0,
        jcj_json: {
          type: 'del',
          reduce_roi: '0',
          min_roi: '',
        },
        close_open: 0,
      },

      adDrawer: false,
      pz: '',
      stop_time_open: false,
      open_time_open: false,
      day_time_open: false,
      diy_day_time_open: false,
    };
  },

  computed: {
    showZdcjRoiAdjustment() {
      const action = this.warnCondition?.zdcj_json?.action;
      return action === 'delcj' || action === 'wcbdelcj';
    },
    showZdcjMinRoi() {
      if (!this.showZdcjRoiAdjustment) return false;
      const reduce = Number(this.warnCondition?.zdcj_json?.reduce_roi);
      return !Number.isNaN(reduce) && reduce > 0;
    },
    showJcjRoiAdjustment() {
      // 转净成交功能总是显示ROI调整选项
      return true;
    },
    showJcjMinRoi() {
      if (!this.showJcjRoiAdjustment) return false;
      const reduce = Number(this.warnCondition?.jcj_json?.reduce_roi);
      return !Number.isNaN(reduce) && reduce > 0;
    },
  },

  components: {
    // AwemeList: awemeList,
    AdVideoList,
    AdLiveList,
  },

  watch: {
    advertiser_id(a, b) {
      this.getMonitorDetail();
    },
    marketing_goal(a, b) {
      this.getMonitorDetail();
    },
  },
  mounted() {
    console.log('advertiser_id______', this.advertiser_id);
    this.getMonitorDetail();
    // this.advertiser_id = this.advertiserList[0].advertiser_id
  },
  methods: {
    moment,
    handleRangeChange(dates) {
      if (dates && dates.length === 2) {
        this.warnCondition.zdcj_json.start = moment(dates[0]).format('YYYY-MM-DD');
        this.warnCondition.zdcj_json.end = moment(dates[1]).format('YYYY-MM-DD');
      }else {
        this.warnCondition.zdcj_json.start = '';
        this.warnCondition.zdcj_json.end = '';
      }
    },
    onOpenChange() {
      console.log(11111111111111111);
      this.warnCondition.ksgt_json.isopen =
        this.warnCondition.ksgt_json.isopen != '1' ? '1' : '0';
      this.$forceUpdate();
    },
    onDiyOpenChange() {
      this.warnCondition.diy_json.isopen =
        this.warnCondition.diy_json.isopen != '1' ? '1' : '0';
    },
    getAd(pz) {
      this.pz = pz;
      this.adDrawer = true;
    },
    cpa_bid_type_change(value) {
      this.warnCondition.diy_json.cpa_bid_type = value;
    },
    roi_goal_type_change(value) {
      this.warnCondition.diy_json.roi_goal_type = value;
    },
    budget_type_change(value) {
      this.warnCondition.diy_json.budget_type = value;
    },
    delAd(it, pz) {
      console.log('删除值', it);
      this.warnCondition[pz].ad_ids = this.warnCondition[pz].ad_ids.filter(
        (item) => {
          console.log(item, it);
          return item != it;
        }
      );
      this.$forceUpdate();
    },
    selectAdDrawer(e) {
      console.log('父组件接收到的值', e);
      this.warnCondition[this.pz].ad_ids = e;
      this.adDrawer = false;
    },
    closeAdDrawer() {
      this.adDrawer = false;
    },
    changeX(value) {
      console.log('---', value);
      let rt = this.xData.filter(function (item) {
        return item.name == value;
      });
      console.log('---', rt);
      this.warnCondition.diy_json.x = rt[0].name;
      let val = rt[0].value;
      this.yData.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    changeX2(value) {
      console.log('---', value);
      let rt = this.xData2.filter(function (item) {
        return item.name == value;
      });
      console.log('---', rt);
      this.warnCondition.diy2_json.x = rt[0].name;
      let val = rt[0].value;
      this.yData2.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      this.zData2.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    changeY(value) {
      console.log('---', value);
      let rt = this.yData.filter(function (item) {
        return item.name == value;
      });
      console.log('---', rt);
      this.warnCondition.diy_json.y = rt[0].name;
      let val = rt[0].value;
      this.xData.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    changeY2(value) {
      console.log('---', value);
      let rt = this.yData2.filter(function (item) {
        return item.name == value;
      });
      console.log('---', rt);
      this.warnCondition.diy2_json.y = rt[0].name;
      let val = rt[0].value;
      this.xData2.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      this.zData2.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    changeZ2(value) {
      console.log('---', value);
      let rt = this.zData2.filter(function (item) {
        return item.name == value;
      });
      console.log('---', rt);
      this.warnCondition.diy2_json.z = rt[0].name;
      let val = rt[0].value;
      this.xData2.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      this.yData2.forEach(function (item, i) {
        if (Number(val) === i) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    handleDiyChange(e) {
      this.warnCondition.diy_json.action = e;
    },
    handleDiyChange2(e) {
      this.warnCondition.diy2_json.action = e;
    },
    handleZdcjChange(e) {
      this.warnCondition.zdcj_json.relation = e;
    },
    handleZdcjActionChange(e) {
      this.warnCondition.zdcj_json.action = e;
      if (!this.showZdcjRoiAdjustment) {
        this.warnCondition.zdcj_json.reduce_roi = '0';
        this.warnCondition.zdcj_json.min_roi = '';
      }
    },
    handleZdcjTypeChange(e) {
      this.warnCondition.zdcj_json.type = e;
    },
    handleZdcjReduceChange(value) {
      const numericValue = Number(value);
      if (Number.isNaN(numericValue) || numericValue <= 0) {
        this.warnCondition.zdcj_json.reduce_roi = '0';
        this.warnCondition.zdcj_json.min_roi = '';
        return;
      }
      const clamped = Math.min(50, Math.max(0, numericValue));
      this.warnCondition.zdcj_json.reduce_roi = clamped;
    },
    handleZdcjMinRoiChange(value) {
      if (value === null || value === undefined || value === '') {
        this.warnCondition.zdcj_json.min_roi = '';
        return;
      }
      const numericValue = Number(value);
      this.warnCondition.zdcj_json.min_roi =
        numericValue < 0 ? 0 : Number(numericValue.toFixed(2));
    },
    handleJcjTypeChange(e) {
      this.warnCondition.jcj_json.type = e;
    },
    handleJcjReduceChange(value) {
      const numericValue = Number(value);
      if (Number.isNaN(numericValue) || numericValue <= 0) {
        this.warnCondition.jcj_json.reduce_roi = '0';
        this.warnCondition.jcj_json.min_roi = '';
        return;
      }
      const clamped = Math.min(50, Math.max(0, numericValue));
      this.warnCondition.jcj_json.reduce_roi = String(clamped);
    },
    handleJcjMinRoiChange(value) {
      if (value === null || value === undefined || value === '') {
        this.warnCondition.jcj_json.min_roi = '';
        return;
      }
      const numericValue = Number(value);
      this.warnCondition.jcj_json.min_roi =
        numericValue < 0 ? 0 : Number(numericValue.toFixed(2));
    },
    handleXChange(e) {
      this.warnCondition.diy_json.x_relation = e;
    },
    handleYChange(e) {
      this.warnCondition.diy_json.y_relation = e;
    },
    handleXChange2(e) {
      this.warnCondition.diy2_json.x_relation = e;
    },
    handleYChange2(e) {
      this.warnCondition.diy2_json.y_relation = e;
    },
    handleZChange2(e) {
      this.warnCondition.diy2_json.z_relation = e;
    },
    changeDiffer(e) {
      if (this.warnCondition.zjys_json.differ > 50) {
        this.warnCondition.zjys_json.differ = 10;
      }
      this.warnCondition.zjys_json.differ_unit = e;
    },
    changeYsDiffer(e) {
      if (this.warnCondition.ysjk_json.differ > 80) {
        this.warnCondition.ysjk_json.differ = 10;
      }
      this.warnCondition.ysjk_json.differ_unit = e;
    },
    changeYjDiffer(e) {
      if (this.warnCondition.zdyj_json.differ > 50) {
        this.warnCondition.zdyj_json.differ = 10;
      }
      this.warnCondition.zdyj_json.differ_unit = e;
    },
    handleZjysChange(e) {
      this.warnCondition.zjys_json.action = e;
    },
    handleZdyjChange(e) {
      console.log(e);
      this.warnCondition.zdyj_json.action = e;
    },
    changeBudget(e) {
      if (this.warnCondition.zjys_json.budget > 50) {
        this.warnCondition.zjys_json.budget = 10;
      }
      this.warnCondition.zjys_json.budget_unit = e;
    },
    changeYjBudget(e) {
      if (this.warnCondition.zdyj_json.budget > 50) {
        this.warnCondition.zdyj_json.budget = 10;
      }
      this.warnCondition.zdyj_json.budget_unit = e;
    },
    changeYjBid(e) {
      console.log('配置压价单位', e);
      if (this.warnCondition.zdyj_json.bid > 50) {
        this.warnCondition.zdyj_json.bid = 10;
      }
      this.warnCondition.zdyj_json.bid_unit = e;
    },
    changeYjRoi(e) {
      if (this.warnCondition.zdyj_json.yjroi > 50) {
        this.warnCondition.zdyj_json.yjroi = 10;
      }
      this.warnCondition.zdyj_json.yjroi_unit = e;
    },
    onDayChange(time, timeString, pz) {
      this.warnCondition[pz].dotime = timeString;
    },
    // 多时段时间变化处理
    onMultiTimeChange(timeString, index, pz) {
      if (this.warnCondition[pz] && this.warnCondition[pz].times) {
        // 检查时间是否重复
        const duplicateIndex = this.warnCondition[pz].times.findIndex(
          (t, i) => t === timeString && i !== index
        );
        if (duplicateIndex !== -1) {
          this.$message.warning('该时间段已存在，请选择其他时间');
          return;
        }
        this.$set(this.warnCondition[pz].times, index, timeString);
      }
    },
    // 添加多时段
    addMultiTime(pz) {
      if (!this.warnCondition[pz].times) {
        this.$set(this.warnCondition[pz], 'times', []);
      }
      // 默认添加时间为当前时间的下一个整点
      const now = moment();
      const nextHour = moment(now).add(1, 'hour').startOf('hour');
      const defaultTime = nextHour.format('HH:mm');
      // 检查时间是否重复
      if (this.warnCondition[pz].times.includes(defaultTime)) {
        // 如果重复，尝试下一个整点
        const nextNextHour = moment(now).add(2, 'hour').startOf('hour');
        const altTime = nextNextHour.format('HH:mm');
        if (!this.warnCondition[pz].times.includes(altTime)) {
          this.warnCondition[pz].times.push(altTime);
        } else {
          // 如果还是重复，使用最后一个时间段加1小时
          const lastTime = this.warnCondition[pz].times[this.warnCondition[pz].times.length - 1];
          const lastMoment = moment(lastTime, 'HH:mm');
          const newTime = moment(lastMoment).add(1, 'hour').format('HH:mm');
          this.warnCondition[pz].times.push(newTime);
        }
      } else {
        this.warnCondition[pz].times.push(defaultTime);
      }
    },
    // 删除多时段
    removeMultiTime(index, pz) {
      if (this.warnCondition[pz] && this.warnCondition[pz].times) {
        if (this.warnCondition[pz].times.length <= 1) {
          this.$message.warning('至少需要保留一个时段');
          return;
        }
        this.warnCondition[pz].times.splice(index, 1);
      }
    },

    getAdvertiserId(advertiser_id) {
      console.log('子组件传回的值', advertiser_id);
      this.advertiser_id = advertiser_id;
      // this.getNearData()
    },
    async getMonitorDetail() {
      console.log('获取详情');
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_MONITOR_DETAIL}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          monitor_type: this.monitor_type,
          ad_id: this.ad_id ? this.ad_id : '',
          product_id: this.product_id ? this.product_id : '',
          adlab_scene:'OVERALL_PROJECT',
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) {
        this.warnCondition = {
          day: '1',
          data_period: 'ALL_DATA',
          ksgt_open: 0,
          ksgt_json: {
            roi: '',
            stat_cost: '',
            action: 'wxstop',
            times: '1',
            differ: '10',
            start: '',
            end: '',
            isopen: 0,
            dotime: '08:00',
          },
          gcft_open: 0,
          gcft_json: {
            roi: '',
            stat_cost: '',
            action: 'wxcreate',
            times: '1',
          },
          gcfk_open: 0,
          gcfk_json: {
            roi: '',
            stat_cost: '',
            action: 'wxopen',
            times: '1',
            start: '',
            end: '',
          },
          zjys_open: 0, //追加预算
          zjys_json: {
            roi: '',
            differ: '',
            differ_unit: '1',
            budget: '',
            budget_unit: '1',
            times: '1',
            action: 'wxzt',
            range: '0',
          },
          bdtz_open: 0,
          bdtz_json: {
            stat_cost: '',
            pay_order_count: '',
            times: 1,
          },
          zdyj_open: 0, //追加预算
          zdyj_json: {
            roi: '',
            differ: '',
            differ_unit: '1',
            budget: '',
            budget_unit: '1',
            bid: '',
            bid_unit: '1',
            times: '1',
            action: 'wx',
            range: '0',
            ad_ids: [],
            start: '',
            end: '',
          },
          dsgt_open: 0, //定时关停
          dsgt_json: {
            action: 'wxstop',
            dotime: '04:00',
            ad_ids: [],
          },
          dsfk_open: 0, //定时开启
          dsfk_json: {
            action: 'wxopen',
            dotime: '08:00',
            ad_ids: [],
          },
          dsgt_multi_open: 0, //多时段关停
          dsgt_multi_json: {
            action: 'wxstop',
            times: ['04:00'],
            ad_ids: [],
          },
          dsfk_multi_open: 0, //多时段开启
          dsfk_multi_json: {
            action: 'wxopen',
            times: ['08:00'],
            ad_ids: [],
          },
          kxtx_open: 0,
          kxtx_minute: 10,
          kxtx_json: {
            stat_cost: '',
          },
          pfgt_open: 0,
          pfgt_json: {
            stat_cost: '',
            roi: '',
          },
          ysjk_open: 0,
          ysjk_json: {
            differ: '',
            differ_unit: '1',
          },
          zdcj_open: 0,
          zdcj_json: {
            day: '5',
            count: '1',
            stat_cost: '0',
            relation: '<=',
            reduce_roi: '0',
            push_notice:true,
            dubble:false,
            start:'',
            end:'',
            action: 'delcj',
            type: 'del',
            limit:'500'
          },
          yjts_open: 0,
          diy_open: 0,
          diy_json: {
            x: 'stat_cost',
            x_value: '',
            x_relation: '>',
            y: 'total_prepay_and_pay_order_roi2',
            y_value: '',
            y_relation: '>',
            action: 'wxstop',
            iscopy: 0,
            isbid: '0',
            isroi: '0',
            isbuget: '0',
            cpa_bid: '',
            cpa_bid_type: '2',
            budget: '',
            budget_type: '2',
            roi_goal: '',
            roi_goal_type: '2',
            start: '',
            end: '',
          },
          diy2_open: 0,
          diy2_json: {
            x: 'stat_cost',
            x_value: '',
            x_relation: '>',
            y: 'total_prepay_and_pay_order_roi2',
            y_value: '',
            y_relation: '>',
            z: 'total_pay_order_count_for_roi2',
            z_value: '',
            z_relation: '>',
            action: 'wxstop',
            start: '',
            end: '',
          },
          xgys_open: 0, //定时改预算
          xgys_json: {
            action: 'wxedit',
            dotime: '', // 移除默认时间，让用户自由选择
            ad_ids: [],
            new_budget: '',
          },
          buget_open: 0,
          close_open: 0,
        };
        return;
      }
      this.warnCondition.day = data.day;
      this.warnCondition.data_period = data.data_period || 'ALL_DATA';
      this.warnCondition.ksgt_open = data.ksgt_open;
      this.warnCondition.gcft_open = data.gcft_open;
      this.warnCondition.gcfk_open = data.gcfk_open;
      this.warnCondition.ysjk_open = data.ysjk_open;
      this.warnCondition.zjys_open = data.zjys_open;
      this.warnCondition.bdtz_open = data.bdtz_open;
      this.warnCondition.zdyj_open = data.zdyj_open;
      this.warnCondition.kxtx_open = data.kxtx_open;
      this.warnCondition.pfgt_open = data.pfgt_open;
      this.warnCondition.kxtx_minute = data.kxtx_minute;
      this.warnCondition.pfgt_minute = data.pfgt_minute;
      this.warnCondition.yjts_open = data.yjts_open;
      this.warnCondition.dsgt_open = data.dsgt_open;
      this.warnCondition.zdcj_open = data.zdcj_open;
      this.warnCondition.dsfk_open = data.dsfk_open;
      this.warnCondition.diy_open = data.diy_open;
      this.warnCondition.diy2_open = data.diy2_open;
      this.warnCondition.xgys_open = data.xgys_open;
      this.warnCondition.buget_open = data.buget_open;
      this.warnCondition.jcj_open = data.jcj_open;
      this.warnCondition.close_open = data.close_open || 0;

      if (data.ksgt_json) {
        this.warnCondition.ksgt_json = {
          ...this.warnCondition.ksgt_json,
          ...data.ksgt_json
        };
      }
      if (data.gcft_json) {
        this.warnCondition.gcft_json = {
          ...this.warnCondition.gcft_json,
          ...data.gcft_json
        };
      }
      if (data.gcfk_json) {
        this.warnCondition.gcfk_json = {
          ...this.warnCondition.gcfk_json,
          ...data.gcfk_json
        };
      }
      if (data.ysjk_json) {
        this.warnCondition.ysjk_json = {
          ...this.warnCondition.ysjk_json,
          ...data.ysjk_json
        };
      }
      if (data.zjys_json) {
        this.warnCondition.zjys_json = {
          ...this.warnCondition.zjys_json,
          ...data.zjys_json
        };
      }
      if (data.bdtz_json) {
        this.warnCondition.bdtz_json = {
          ...this.warnCondition.bdtz_json,
          ...data.bdtz_json
        };
      }
      if (data.zdyj_json) {
        this.warnCondition.zdyj_json = {
          ...this.warnCondition.zdyj_json,
          ...data.zdyj_json
        };
      }
      if (data.kxtx_json) {
        this.warnCondition.kxtx_json = {
          ...this.warnCondition.kxtx_json,
          ...data.kxtx_json
        };
      }
      if (data.zdcj_json) {
        this.warnCondition.zdcj_json = {
          ...this.warnCondition.zdcj_json,
          ...data.zdcj_json
        };
      }
      if (data.pfgt_json) {
        this.warnCondition.pfgt_json = {
          ...this.warnCondition.pfgt_json,
          ...data.pfgt_json
        };
      }
      if (data.diy_json) {
        this.warnCondition.diy_json = {
          ...this.warnCondition.diy_json,
          ...data.diy_json,
          iscopy: data.diy_json.iscopy ?? this.warnCondition.diy_json.iscopy ?? 0
        };
      }
      if (data.diy2_json) {
        this.warnCondition.diy2_json = {
          ...this.warnCondition.diy2_json,
          ...data.diy2_json
        };
      }
      if (data.jcj_json) {
        this.warnCondition.jcj_json = {
          ...this.warnCondition.jcj_json,
          ...data.jcj_json
        };
      }
      if (data.xgys_json) {
        // 合并数据，确保不会覆盖已有的有效数据
        let dotime = data.xgys_json.dotime || this.warnCondition.xgys_json.dotime || '';
        
        // 如果从服务器获取的时间格式不正确，尝试格式化
        if (dotime) {
          const timeMoment = moment(dotime);
          if (timeMoment.isValid()) {
            dotime = timeMoment.format('YYYY-MM-DD HH:mm');
          } else {
            dotime = ''; // 如果时间格式无效，清空让用户重新选择
          }
        }
        
        this.warnCondition.xgys_json = {
          ...this.warnCondition.xgys_json, // 保留现有数据
          ...data.xgys_json, // 覆盖服务器数据
          dotime: dotime
        };
      }
      if (data.dsgt_json) {
        this.warnCondition.dsgt_json = {
          ...this.warnCondition.dsgt_json,
          ...data.dsgt_json
        };
      }
      if (data.dsfk_json) {
        this.warnCondition.dsfk_json = {
          ...this.warnCondition.dsfk_json,
          ...data.dsfk_json
        };
      }
      if (data.dsgt_multi_json) {
        this.warnCondition.dsgt_multi_json = {
          ...this.warnCondition.dsgt_multi_json,
          ...data.dsgt_multi_json
        };
        // 确保 times 数组存在
        if (!this.warnCondition.dsgt_multi_json.times || this.warnCondition.dsgt_multi_json.times.length === 0) {
          this.warnCondition.dsgt_multi_json.times = ['04:00'];
        }
      }
      if (data.dsfk_multi_json) {
        this.warnCondition.dsfk_multi_json = {
          ...this.warnCondition.dsfk_multi_json,
          ...data.dsfk_multi_json
        };
        // 确保 times 数组存在
        if (!this.warnCondition.dsfk_multi_json.times || this.warnCondition.dsfk_multi_json.times.length === 0) {
          this.warnCondition.dsfk_multi_json.times = ['08:00'];
        }
      }
      if (data.dsgt_multi_open !== undefined) {
        this.warnCondition.dsgt_multi_open = data.dsgt_multi_open;
      }
      if (data.dsfk_multi_open !== undefined) {
        this.warnCondition.dsfk_multi_open = data.dsfk_multi_open;
      }

      this.warnCondition.ksgt_json.isopen = data.ksgt_json.isopen ?? '0';
      this.warnCondition.ksgt_json.dotime = data.ksgt_json.dotime ?? '08:00';

      // 验证关键字段，确保时间选择器能正常工作
      this.validateAndFixTimeFields();

      console.log('获取详情', this.warnCondition);
    },
    onRangeChange() {
      this.warnCondition.zjys_json.range =
        this.warnCondition.zjys_json.range != '1' ? '1' : '0';
    },
    onRangeBid() {
      this.warnCondition.diy_json.isbid =
        this.warnCondition.diy_json.isbid != '1' ? '1' : '0';
    },
    onRangeRoi() {
      this.warnCondition.diy_json.isroi =
        this.warnCondition.diy_json.isroi != '1' ? '1' : '0';
    },
    onRangeBuget() {
      this.warnCondition.diy_json.isbuget =
        this.warnCondition.diy_json.isbuget != '1' ? '1' : '0';
    },
    onRangeYjChange() {
      console.log(this.warnCondition.zdyj_json.range);
      this.warnCondition.zdyj_json.range =
        this.warnCondition.zdyj_json.range != '1' ? '1' : '0';
      console.log(this.warnCondition.zdyj_json.range);
    },
    async setMonitor() {
      console.log(this.warnCondition);
      if (this.advertiser_id == '') {
        this.$message.error('请选择户ID');
        return;
      }
      if (this.warnCondition.ksgt_open) {
        if (!this.warnCondition.ksgt_json) {
          this.$message.error('您已开启【亏损关停】配置，请配置参数');
          return;
        }
        if (this.warnCondition.ksgt_json.roi == '') {
          this.$message.error('您已开启【亏损关停】配置，请设置ROI指标');
          return;
        }
        if (this.warnCondition.ksgt_json.stat_cost == '') {
          this.$message.error('您已开启【亏损关停】配置，请设置消耗指标');
          return;
        }
        if (
          this.warnCondition.ksgt_json.times > 1 &&
          this.warnCondition.ksgt_json.differ == ''
        ) {
          this.$message.error('您已开启【亏损关停】配置，请设置每次消耗间隔');
          return;
        }
        if (!isNumber(this.warnCondition.ksgt_json.times)) {
          this.$message.error('您已开启【亏损关停】配置，请设置执行次数');
          return;
        }
        console.log('aaa', this.warnCondition.ksgt_json.times);
        if (
          this.warnCondition.ksgt_json.times > 1 &&
          !isNumber(this.warnCondition.ksgt_json.differ)
        ) {
          this.$message.error(
            '您已开启【亏损关停】配置，每次消耗间隔只能为数字'
          );
          return;
        }
        if (this.warnCondition.ksgt_json.times == 1) {
          this.warnCondition.ksgt_json.differ = 10;
        }

        if (
          this.warnCondition.ksgt_json.start != '' &&
          this.warnCondition.ksgt_json.end != ''
        ) {
          if (
            this.warnCondition.ksgt_json.start >
            this.warnCondition.ksgt_json.end
          ) {
            this.$message.error(
              '您已开启【亏损关停】配置，投放时段开始时间不能小于结束时间'
            );
            return;
          }
        }
      }
      if (this.warnCondition.gcft_open) {
        if (!this.warnCondition.gcft_json) {
          this.$message.error('您已开启【高产复投】配置，请配置参数');
          return;
        }
        if (this.warnCondition.gcft_json.roi == '') {
          this.$message.error('您已开启【高产复投】配置，请设置ROI指标');
          return;
        }
        if (this.warnCondition.gcft_json.stat_cost == '') {
          this.$message.error('您已开启【高产复投】配置，请设置消耗指标');
          return;
        }
      }
      if (this.warnCondition.gcfk_open) {
        if (!this.warnCondition.gcfk_json) {
          this.$message.error('您已开启【高产复开】配置，请配置参数');
          return;
        }
        if (this.warnCondition.gcfk_json.roi == '') {
          this.$message.error('您已开启【高产复开】配置，请设置ROI指标');
          return;
        }
      }
      if (this.warnCondition.zjys_open) {
        if (!this.warnCondition.zjys_json) {
          this.$message.error('您已开启【追加预算】配置，请配置参数');
          return;
        }
        if (this.warnCondition.zjys_json.roi == '') {
          this.$message.error('您已开启【追加预算】配置，请设置ROI指标');
          return;
        }
        if (this.warnCondition.zjys_json.differ == '') {
          this.$message.error('您已开启【追加预算】配置，请设置计划剩余金额');
          return;
        }
        if (
          this.warnCondition.zjys_json.budget == '' &&
          this.warnCondition.zjys_json.action == 'wxzt'
        ) {
          this.$message.error('您已开启【追加预算】配置，请设置需要追加的预算');
          return;
        }
      }

      if (this.warnCondition.zdyj_open) {
        if (!this.warnCondition.zdyj_json) {
          this.$message.error('您已开启【自动压价】配置，请配置参数');
          return;
        }
        if (this.warnCondition.zdyj_json.roi == '') {
          this.$message.error('您已开启【自动压价】配置，请设置ROI指标');
          return;
        }
        if (this.warnCondition.zdyj_json.differ == '') {
          this.$message.error('您已开启【自动压价】配置，请设置计划剩余金额');
          return;
        }
        if (this.warnCondition.zdyj_json.action == 'wxyj') {
          if (this.warnCondition.zdyj_json.budget == '') {
            this.$message.error(
              '您已开启【自动压价】配置，请设置需要追加的预算'
            );
            return;
          }
          if (this.warnCondition.zdyj_json.bid == '') {
            this.$message.error(
              '您已开启【自动压价】配置，请设置需要调整的出价'
            );
            return;
          }
        }
      }
      if (this.warnCondition.kxtx_open) {
        if (!this.warnCondition.kxtx_json) {
          this.$message.error('您已开启【快消提醒】配置，请配置参数');
          return;
        }
        if (this.warnCondition.kxtx_json.stat_cost == '') {
          this.$message.error('您已开启【快消提醒】配置，请设置消耗指标');
          return;
        }
      }
      if (this.warnCondition.pfgt_open) {
        if (!this.warnCondition.pfgt_json) {
          this.$message.error('您已开启【跑飞关停】配置，请配置参数');
          return;
        }
        if (this.warnCondition.pfgt_json.stat_cost == '') {
          this.$message.error('您已开启【跑飞关停】配置，请设置消耗指标');
          return;
        }
        if (this.warnCondition.pfgt_json.roi == '') {
          this.$message.error('您已开启【跑飞关停】配置，请设置ROI指标');
          return;
        }
      }
      if (this.warnCondition.bdtz_open) {
        if (!this.warnCondition.bdtz_json) {
          this.$message.error('您已开启【爆单通知】配置，请配置参数');
          return;
        }
        if (this.warnCondition.bdtz_json.pay_order_count == '') {
          this.$message.error('您已开启【爆单通知】配置，请设置成交订单数');
          return;
        }
        if (this.warnCondition.bdtz_json.stat_cost == '') {
          this.$message.error('您已开启【爆单通知】配置，请设置消耗指标');
          return;
        }
      }

      if (this.warnCondition.xgys_open) {
        if (!this.warnCondition.xgys_json) {
          this.$message.error('您已开启【定时改预算】配置，请配置参数');
          return;
        }
        if (!this.warnCondition.xgys_json.dotime || this.warnCondition.xgys_json.dotime === '') {
          this.$message.error('您已开启【定时改预算】配置，请设置执行时间');
          return;
        }
        // 确保时间格式为 YYYY-MM-DD HH:mm
        if (this.warnCondition.xgys_json.dotime) {
          const timeMoment = moment(this.warnCondition.xgys_json.dotime);
          if (!timeMoment.isValid()) {
            this.$message.error('您已开启【定时改预算】配置，请设置正确的执行时间格式');
            return;
          }
          // 格式化时间为 YYYY-MM-DD HH:mm 格式
          this.warnCondition.xgys_json.dotime = timeMoment.format('YYYY-MM-DD HH:mm');
        }
        if (!this.warnCondition.xgys_json.new_budget || this.warnCondition.xgys_json.new_budget === '') {
          this.$message.error('您已开启【定时改预算】配置，请设置修改后的预算值');
          return;
        }
        if (this.warnCondition.xgys_json.new_budget <= 0) {
          this.$message.error('您已开启【定时改预算】配置，修改后的预算值必须大于0');
          return;
        }
      }

      if (this.ad_id && this.warnCondition.dsgt_open) {
        this.warnCondition.dsgt_json.ad_ids = [this.ad_id];
      }
      if (this.ad_id && this.warnCondition.dsfk_open) {
        this.warnCondition.dsfk_json.ad_ids = [this.ad_id];
      }
      if (this.ad_id && this.warnCondition.dsgt_multi_open) {
        this.warnCondition.dsgt_multi_json.ad_ids = [this.ad_id];
      }
      if (this.ad_id && this.warnCondition.dsfk_multi_open) {
        this.warnCondition.dsfk_multi_json.ad_ids = [this.ad_id];
      }
      if (this.ad_id && this.warnCondition.xgys_open) {
        this.warnCondition.xgys_json.ad_ids = [this.ad_id];
      }

      if (this.warnCondition.dsgt_open) {
        if (this.warnCondition.dsgt_json.ad_ids.length == 0) {
          this.$message.error('您已开启【定时关停】配置，请选择计划');
          return;
        }
      }

      if (this.warnCondition.dsfk_open) {
        if (this.warnCondition.dsfk_json.ad_ids.length == 0) {
          this.$message.error('您已开启【定时开启】配置，请选择计划');
          return;
        }
      }

      if (this.warnCondition.dsgt_multi_open) {
        if (!this.warnCondition.dsgt_multi_json.times || this.warnCondition.dsgt_multi_json.times.length === 0) {
          this.$message.error('您已开启【多时段关停】配置，请至少添加一个时段');
          return;
        }
        if (this.warnCondition.dsgt_multi_json.ad_ids.length == 0) {
          this.$message.error('您已开启【多时段关停】配置，请选择计划');
          return;
        }
      }

      if (this.warnCondition.dsfk_multi_open) {
        if (!this.warnCondition.dsfk_multi_json.times || this.warnCondition.dsfk_multi_json.times.length === 0) {
          this.$message.error('您已开启【多时段开启】配置，请至少添加一个时段');
          return;
        }
        if (this.warnCondition.dsfk_multi_json.ad_ids.length == 0) {
          this.$message.error('您已开启【多时段开启】配置，请选择计划');
          return;
        }
      }

      if (this.warnCondition.xgys_open) {
        if (this.warnCondition.xgys_json.ad_ids.length == 0) {
          this.$message.error('您已开启【定时改预算】配置，请选择计划');
          return;
        }
      }
      if (this.warnCondition.diy_open) {
        if (!this.warnCondition.diy_json) {
          this.$message.error('您已开启【自定义监控】配置，请配置参数');
          return;
        }
        if (this.warnCondition.diy_json.x_value == '') {
          this.$message.error('您已开启【自定义监控】配置，请设置参数1');
          return;
        }
        if (this.warnCondition.diy_json.y_value == '') {
          this.$message.error('您已开启【自定义监控】配置，请设置参数2');
          return;
        }

        if (typeof this.warnCondition.diy_json.isbid != 'undefined') {
          console.log(
            '11111111111111111111111',
            this.warnCondition.diy_json.cpa_bid
          );
          if (
            this.warnCondition.diy_json.isbid == '1' &&
            this.warnCondition.diy_json.cpa_bid_type == '2' &&
            this.warnCondition.diy_json.cpa_bid_type == '3'
          ) {
            this.$message.error(
              '您已开启【自定义监控】调整出价配置，请设置出价提高或降低'
            );
            return;
          }
          if (
            this.warnCondition.diy_json.isbid == '1' &&
            typeof this.warnCondition.diy_json.cpa_bid == 'undefined'
          ) {
            this.$message.error(
              '您已开启【自定义监控】调整出价配置，请设置出价提高或降低的值'
            );
            return;
          }
        }

        if (typeof this.warnCondition.diy_json.isroi != 'undefined') {
          if (
            this.warnCondition.diy_json.isroi == '1' &&
            this.warnCondition.diy_json.roi_goal_type == '2' &&
            this.warnCondition.diy_json.roi_goal_type == '3'
          ) {
            this.$message.error(
              '您已开启【自定义监控】调整ROI配置，请设置ROI提高或降低'
            );
            return;
          }
          if (
            this.warnCondition.diy_json.isroi == '1' &&
            typeof this.warnCondition.diy_json.roi_goal == 'undefined'
          ) {
            this.$message.error(
              '您已开启【自定义监控】调整ROI配置，请设置ROI提高或降低的值'
            );
            return;
          }
        }

        if (typeof this.warnCondition.diy_json.isbuget != 'undefined') {
          if (
            this.warnCondition.diy_json.isbuget == '1' &&
            this.warnCondition.diy_json.budget_type == '2' &&
            this.warnCondition.diy_json.budget_type == '3'
          ) {
            this.$message.error(
              '您已开启【自定义监控】调整预算配置，请设置预算提高或降低'
            );
            return;
          }
          if (
            this.warnCondition.diy_json.isbuget == '1' &&
            typeof this.warnCondition.diy_json.budget == 'undefined'
          ) {
            this.$message.error(
              '您已开启【自定义监控】调整预算配置，请设置预算提高或降低的值'
            );
            return;
          }
        }
      }

      if (this.warnCondition.diy2_open) {
        if (!this.warnCondition.diy2_json) {
          this.$message.error('您已开启【自定义监控2】配置，请配置参数');
          return;
        }
        if (this.warnCondition.diy2_json.x_value == '') {
          this.$message.error('您已开启【自定义监控2】配置，请设置参数1');
          return;
        }
        if (this.warnCondition.diy2_json.y_value == '') {
          this.$message.error('您已开启【自定义监控2】配置，请设置参数2');
          return;
        }
      }
      if (this.warnCondition.jcj_open) {
        if (!this.warnCondition.jcj_json) {
          this.$message.error('您已开启【转净成交】配置，请配置参数');
          return;
        }
        if (!isNumber(this.warnCondition.jcj_json.reduce_roi)) {
          this.$message.error('您已开启【转净成交】配置，请设置减少ROI百分比');
          return;
        }
        const reduceRoi = Number(this.warnCondition.jcj_json.reduce_roi);
        if (reduceRoi > 0 && this.warnCondition.jcj_json.min_roi !== '') {
          const minRoi = Number(this.warnCondition.jcj_json.min_roi);
          if (Number.isNaN(minRoi) || minRoi < 0) {
            this.$message.error('您已开启【转净成交】配置，ROI最低值必须大于等于0');
            return;
          }
        }
      }

      let that = this;
      this.confirmLoading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SET_QY_MONITOR}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal: this.marketing_goal,
          monitor_type: this.monitor_type,
          ad_id: this.ad_id,
          product_id: this.product_id,
          warnCondition: JSON.stringify(this.warnCondition),
          adlab_scene:'OVERALL_PROJECT',
        },
      });
      this.confirmLoading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (code == 0) {
        this.$message.error(msg);
      } else {
        this.$emit('closeRuleModal');
        this.$message.success(msg);
      }
    },
    handleChange(e) {
      console.log(e);
      this.advertiser_id = e;
    },
    handleKsgtChange(e) {
      this.warnCondition.ksgt_json.action = e;
    },
    handleGcftChange(e) {
      this.warnCondition.gcft_json.action = e;
    },
    handleGcfkChange(e) {
      this.warnCondition.gcfk_json.action = e;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    //修改营销目的
    markePurposeChange(e) {
      this.marketing_goal = e.target.value;
    },
    handleOk() {
      this.$emit('closeRuleModal');
    },

    handleCancel() {
      this.$emit('closeRuleModal');
    },
    validateAndFixTimeFields() {
      // 验证并修复时间字段，确保时间选择器能正常工作
      
      // 验证 xgys_json.dotime - 移除时间限制验证，只验证格式
      if (this.warnCondition.xgys_json && this.warnCondition.xgys_json.dotime) {
        const xgysTime = moment(this.warnCondition.xgys_json.dotime, 'YYYY-MM-DD HH:mm');
        if (!xgysTime.isValid()) {
          this.warnCondition.xgys_json.dotime = ''; // 清空无效时间，让用户重新选择
        }
      }
      
      // 验证其他时间字段
      if (this.warnCondition.ksgt_json && this.warnCondition.ksgt_json.dotime) {
        const ksgtTime = moment(this.warnCondition.ksgt_json.dotime, 'HH:mm');
        if (!ksgtTime.isValid()) {
          this.warnCondition.ksgt_json.dotime = '08:00';
        }
      }
      
      if (this.warnCondition.dsgt_json && this.warnCondition.dsgt_json.dotime) {
        const dsgtTime = moment(this.warnCondition.dsgt_json.dotime, 'HH:mm');
        if (!dsgtTime.isValid()) {
          this.warnCondition.dsgt_json.dotime = '04:00';
        }
      }
      
      if (this.warnCondition.dsfk_json && this.warnCondition.dsfk_json.dotime) {
        const dsfkTime = moment(this.warnCondition.dsfk_json.dotime, 'HH:mm');
        if (!dsfkTime.isValid()) {
          this.warnCondition.dsfk_json.dotime = '08:00';
        }
      }
      
      // 验证多时段关停时间
      if (this.warnCondition.dsgt_multi_json && this.warnCondition.dsgt_multi_json.times) {
        this.warnCondition.dsgt_multi_json.times = this.warnCondition.dsgt_multi_json.times.filter(time => {
          const timeMoment = moment(time, 'HH:mm');
          return timeMoment.isValid();
        }).map(time => {
          const timeMoment = moment(time, 'HH:mm');
          return timeMoment.isValid() ? timeMoment.format('HH:mm') : '04:00';
        });
        // 如果没有有效时间，添加默认时间
        if (this.warnCondition.dsgt_multi_json.times.length === 0) {
          this.warnCondition.dsgt_multi_json.times = ['04:00'];
        }
      }
      
      // 验证多时段开启时间
      if (this.warnCondition.dsfk_multi_json && this.warnCondition.dsfk_multi_json.times) {
        this.warnCondition.dsfk_multi_json.times = this.warnCondition.dsfk_multi_json.times.filter(time => {
          const timeMoment = moment(time, 'HH:mm');
          return timeMoment.isValid();
        }).map(time => {
          const timeMoment = moment(time, 'HH:mm');
          return timeMoment.isValid() ? timeMoment.format('HH:mm') : '08:00';
        });
        // 如果没有有效时间，添加默认时间
        if (this.warnCondition.dsfk_multi_json.times.length === 0) {
          this.warnCondition.dsfk_multi_json.times = ['08:00'];
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ant-switch {
  margin-left: 20px;
}
.ant-modal-body {
  padding: 10px 24px;
}
.confBlock {
  background: #fff;
  margin-bottom: 12px;
  border-radius: 4px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.2);
  padding: 16px 24px;
  .cofBlockName {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &::before {
      content: '';
      width: 4px;
      height: 14px;
      background-color: #2b6afd;
      margin-right: 8px;
      display: inline-block;
    }
  }
  .confContent {
    margin-top: 20px;
  }
  .warnTypeBtn {
    margin-right: 10px;
    &.checked {
      border-color: #1890ff;
      color: #1890ff;
    }
  }
  .highlightTxt {
    color: #1890ff;
    font-size: 12px;
  }
  .confLine {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    &.fxStart {
      align-items: flex-start;
      .confLable {
        margin-top: 6px;
      }
    }
    .confLable {
      width: 90px;
      text-align: right;
      margin: 0px 10px 0 0;
    }
    .hintBlock {
      margin-top: 8px;
      font-size: 12px;
    }
    .conditionInput {
      width: 120px;
      margin-right: 10px;
    }
    .actionCondition {
      margin-bottom: 8px;
    }
  }
}
.tags-area-body {
  overflow-y: auto;
  // display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  align-content: flex-start;
  width: 720px;
  .tag {
    display: flex;
    align-items: center;
    width: 24%;
    float: left;
    height: 26px;
    overflow: hidden;
    background-color: #f2f2f2;
    border-radius: 4px;
    margin: 6px auto 0 6px;
    // margin-right: 10px;
    // margin-top: 10px;
    padding: 2px 6px;
    color: #999;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;

    .tag-icon {
      width: 14px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
}
</style>
